import React from "react";
import { H2, P } from "../../styles";
import Button from "../../components/Button/Button";
import { useTranslation } from "react-i18next";
import NvidiaContainer from "../../hoc/NvidiaContainer";
import { ButtonsContainer } from "../../components/Button/styles";
const Redeem = ({ locale }) => {
  const { t } = useTranslation();
  const navigateToRedeem = () => {
    location.href = `${locale !== "zh-cn" ? "/" + locale : ""}${VRS_URL}`;
  };
  return (
    <NvidiaContainer>
      <H2>{t("Redeem a gift card or promo code.")}</H2>
      <P>
        {t("Enter a code to redeem games, in-game items, and subscriptions.")}
      </P>

      <ButtonsContainer>
        <Button label={t("Redeem")} clickHandler={navigateToRedeem} />
        <Button
          label={t("View redeemed games")}
          clickHandler={navigateToRedeem}
          theme="alt"
        />
      </ButtonsContainer>
    </NvidiaContainer>
  );
};
export default Redeem;
